(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/groups/:id', {
      templateUrl: 'modules/app/settings/your-organization/group/group.html',
      controller: 'GroupSettingsCtrl'
    });
  }]).controller('GroupPermissionsCtrl', ['$scope', '$routeParams', '$controller', '$q', 'Api', function ($scope, $routeParams, $controller, $q, Api) {
    var groupId = $routeParams.id;
    $scope.groupId = groupId;
    $scope.permissionsApiUrl = Api.url("/groups/" + groupId + "/permissions");
    $scope.targetingPermissionsApiUrl = Api.url("/groups/" + groupId + "/targeting-permissions");
  }]).controller('GroupSettingsCtrl', ['$scope', '$controller', '$routeParams', '$uibModal', '$http', 'Api', 'Logger', function ($scope, $controller, $routeParams, $uibModal, $http, Api, Logger) {
    $scope.groupId = $routeParams.id;
    $scope.save = function () {
      $scope.saving = true;
      $http.put(Api.url("/groups/" + $scope.entity.id + "?action=metadata_update"), $scope.entity).then(function updateGroupSuccess() {
        $scope.saving = false;
      }, function updateGroupFailure(response) {
        Logger.error("Error saving group, response status " + response.status);
        $scope.saveError = "There was an error updating the group: " + response.data.message;
        $scope.saving = false;
      });
    };
    $scope.$on('name-changed', function () {
      $scope.save();
    });

    //set these two properties to be used by uploadImageModal
    $scope.uploadUrl = '/images';
    $scope.isOrgLogoImage = true;
    $scope.openImageModal = function () {
      $scope.uploadImageModal = $uibModal.open({
        templateUrl: "modules/common/images/upload-image-modal.html",
        controller: "UploadImageCtrl",
        backdrop: 'static',
        scope: $scope
      });

      // The modal "resolves" to (closes with) image url
      $scope.uploadImageModal.result.then(function (imageUrl) {
        $scope.entity.imageUrl = imageUrl;
        $scope.save();
      });
    };

    //delete image url from organization
    $scope.clearImage = function () {
      $scope.entity.imageUrl = null;
      $scope.save();
    };
    $controller('PersonGroupSettingsCtrl', {
      $scope: $scope
    });
  }]).controller('GroupMembershipsCtrl', ['$controller', '$filter', '$http', '$routeParams', '$scope', '$uibModal', 'Api', function ($controller, $filter, $http, $routeParams, $scope, $uibModal, Api) {
    $scope.defaultSortBy = "name";
    $scope.sortControls = [{
      "title": "Name",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      },
      "colspan": 2
    }, {
      "title": "Emails & Accounts",
      "class": "col-md-6"
    }];
    $scope.processFetchResponse = function (response) {
      _.forEach(response.data.results, function (p) {
        p.personas = _.flatten(_.toArray(_.groupBy(_.sortBy(p.personas, function (p) {
          return $filter('personaDisplay')(p);
        }), function (p) {
          return p.account ? 1 : p.mbox ? 2 : 3;
        })));
      });
      return response.data;
    };
    $scope.showPersonaIdentifiers = true;
    $scope.getApiUrl = Api.url("/groups/" + $routeParams.id + "/members");
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.showAddPerson = false;
    $scope.clearPerson = function () {
      $scope.selectedPerson = null;
      $scope.showAddPerson = false;
    };
    $scope.addPerson = function () {
      if (!$scope.selectedPerson) {
        return;
      }
      var personUrl = Api.url("/people/" + $scope.selectedPerson.id);
      var getPerson = _.partial($http.get, personUrl);
      var savePerson = _.partial($http.put, personUrl);
      var groupId = $routeParams.id;
      getPerson().then(function (response) {
        var person = response.data;
        if (!_.contains(person.parentGroupIds, groupId)) {
          person.parentGroupIds.push(groupId);
        } else {
          return;
        }
        savePerson(person).then(function () {
          $scope.$broadcast("item-added", $scope.selectedPerson);
          $scope.clearPerson();
        });
      });
    };
  }]);
})();
